// extracted by mini-css-extract-plugin
export default {"title":"SplashScreen_title__zheQ9","jump":"SplashScreen_jump__aA4Xu"};